const getDefaultState = () => {
  return {
    isLoggedIn: false,
    jwt_token: '',
    user_id: '',
    user_role: '',
    email: '',
    first_name: '',
    last_name: '',
    // Username exactly as stored on the CRM (the login matches it ignoring case)
    username: '',
    error: '',
    lmsSession: '',
    lmsIsLoggedIn: false,
    userRegion: 'default',
    tracking: true,
    webinarBannerDismissed: false,
  }
}

export const state = () => getDefaultState()
export const mutations = {
  setUser(state, user) {
    state.isLoggedIn = user.isLoggedIn
    state.jwt_token = user.jwt_token
    state.user_id = user.user_id
    state.user_role = user.user_role
    state.email = user.email || ''
    state.first_name = user.first_name || ''
    state.last_name = user.last_name || ''
    state.username = user.username || ''
  },
  setLmsUser(state, user) {
    state.lmsIsLoggedIn = user.lmsIsLoggedIn
    state.lmsSession = user.session
  },
  deleteUser(state) {
    Object.assign(state, getDefaultState())
  },
  setError(state, error) {
    state.error = error
  },
  setRegion(state, region) {
    state.userRegion = region
  },
  setTracking(state, status){
    state.tracking = status
  },
  setWebinarBannerDismissed(state, status){
    state.webinarBannerDismissed = status
  }
}

export const getters = {

  isLoggedIn: (state) => {
    return state.isLoggedIn
  },
  lmsIsLoggedIn: (state) => {
    return state.lmsIsLoggedIn
  },
  jwt: (state) => {
    return state.jwt_token
  },
  id: (state) => {
    return state.user_id
  },
  region: (state) => {
    return state.userRegion
  },
  tracking: (state) => {
    return state.tracking
  },
  webinarBannerDismissed: (state) => {
    return state.webinarBannerDismissed
  }
}
export const actions = {

  // LMS LOGIN
  // Never throws: resolves to the LMS response ({ session, ... }) on success, or
  // { error: true, message } on failure, and logs failures so they can be traced.
  async lmsLogin({
    commit, dispatch, state
  }, data) {
    console.log('LMS LOG IN', process.env.LMS_URL)
    const typed = (data.username || '').trim()
    // The site login matches the username ignoring case and spaces; the LMS may
    // not. Send the CRM's own spelling when it's the same address, otherwise
    // what was typed (trimmed).
    const username = state.username && state.username.toLowerCase() === typed.toLowerCase()
      ? state.username
      : typed

    try {
      const result = await this.$axios.$post(
        process.env.LMS_URL + '/extorio/apis/users/login', {
          username,
          password: data.password,
        }
      )
      if (result && result.session) {
        result.lmsIsLoggedIn = true
        commit('setLmsUser', result)
        return result
      }
      throw Object.assign(new Error('No session in LMS login response'), { lmsBody: result })
    } catch (error) {
      // A reply without a session still means the LMS answered (e.g. wrong password)
      const status = error.response ? error.response.status : (error.lmsBody ? 200 : null)
      const body = error.response ? error.response.data : error.lmsBody
      const message = (body && (body.error_message || body.message || body.error)) ||
        error.message || 'Unable to log in to the course platform'

      // Never log the password
      dispatch('logError', {
        type: 'LMS login failed',
        source: data.source || 'unknown',
        userId: state.user_id,
        usernameSent: username,
        usernameTyped: data.username,
        crmUsername: state.username,
        status,
        message,
        response: body,
      }).catch(() => {})

      return { error: true, status, message }
    }
  },

  // LOGIN
  async login({
    commit
  }, data) {
    console.log('LOG IN', process.env.DATA_URL)
    try {
      let result;
      if (!data.jwt) {

        // Make sure username is lowercase with no whitepsace
        const username = data.username.trim().toLowerCase();
        result = await this.$axios.$post(
          // process.env.DATA_URL + '/auth/customer-login',

          location.protocol + '//' + location.host + '/.netlify/functions/login', {
            username,
            password: data.password,
          }
        )
        result.isLoggedIn = true
        commit('setUser', result)
        return result

      } else {

        result = {
          jwt_token: data.jwt,
          user_id: parseInt(data.userid),
          user_role: 'customer',
          isLoggedIn: true
        }
        commit('setUser', result)
        return result

      }

    } catch (error) {
      commit('setError', error.response.data)
      return error.response.data
    }
  },

  // REGISTER
  async register({
    commit
  }, data) {
    console.log('REGISTER: ', data)
    // Make sure username is lowercase with no whitepsace
    const username = data.username.trim().toLowerCase();
    const registerData = {
      title: null,
      email: username,
      firstname: data.firstname,
      lastname: data.lastname,
      password: data.password,
      line1: null,
      line2: null,
      town: null,
      region: null,
      postcode: null,
      country: data.country,
      dateOfBirth: null,
    };
    // console.log('REGISTER DATA: ', registerData)
    try {
      const result = await this.$axios.$post(
        // process.env.DATA_URL + '/auth/register-customer/',
        location.protocol + '//' + location.host + '/.netlify/functions/register',
        registerData
      )
      return result
    } catch (error) {
      commit('setError', error.response.data)
      return error.response.data
    }
  },

  async requestResetPassword({
    commit
  }, data) {
    const username = data.username.trim().toLowerCase()
    console.log('REQUESTRESETPASSWORD: ', username)
    const resetData = {email:username}

    try {
      const result = await this.$axios.post(
        // location.protocol + '//' + location.host + '/.netlify/functions/requestResetPassword',
        // process.env.NETLIFY_FUNCTION_URL + '/reset/request',
        process.env.DATA_URL + '/customers/request_reset_password/',
        resetData
      )
      console.log('RESULT: ', result)
      return result
    } catch (error) {
      commit('setError', error.response.data)
      return error.response.data
    }

  },


  async resetPassword({
    commit
  }, data) {
    console.log('RESETPASSWORD: ', data)
    // return 'hello from store'
    try {
      const result = await this.$axios.post(
        location.protocol + '//' + location.host + '/.netlify/functions/resetPassword',
        data
      )
      console.log('RESULT: ', result)
      return result
    } catch (error) {
      commit('setError', error.response.data)
      return error.response.data
    }
  },

  // LOG ERROR

  async logError({
    commit
  }, data) {
    console.log('ERROR: ', data)
    // Make sure the data is a string
    data = JSON.stringify(data)
    try {
      const result = await this.$axios.post(
        location.protocol + '//' + location.host + '/.netlify/functions/log',
        data
      )
      console.log('RESULT: ', result)
      return result
    } catch (error) {
      commit('setError', error.response.data)
      return error.response.data
    }
  },

  // LOGOUT
  async logout({
    commit
  }) {
    localStorage.removeItem('tefl_cs_store')
    // The cart is kept so the same customer can sign back in and carry on. If
    // someone else signs in instead, the page-load check and assignCartServer
    // see the order belongs to another customer and start a fresh cart.
    await commit('deleteUser')
  },

  // ADD NOTE
  async addNote({
    commit
  }, data) {
    console.log('ADD NOTE: ', data)
    const noteData = {
      customerId: this.state.user.user_id,
      note: data.note
    }

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/customers/add_note/',
        noteData
      )
      return result
    } catch (error) {
      // commit('setError', error.response.data)
      return error.response.data
    }

  },

  // SEND EMAIL
  async sendEmail({
    commit
  }, data) {
    console.log('SEND EMAIL: ', data)
    const emailData = {
      message: data.email
    }

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/sendmail/generic/',
        JSON.stringify(emailData)
      )
      return result
    } catch (error) {
      // commit('setError', error.response.data)
      return error.response.data
    }

  },

  // CLASS AGREE
  async classAgree({
    commit
  }, data) {
    console.log('CLASS AGREE: ', data)
    const classData = {
      status: data.status,
      obp_id: data.obp_id
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/class_agree/',
        JSON.stringify(classData)
      )
      return result
    } catch (error) {
      // commit('setError', error.response.data)
      return error.response.data
    }
  },

  // Update Shipping Address
  async updateAddress({
    commit
  }, data) {
    console.log('SHIPPING ADDRESS: ', data)
    const addressData = {
      customerId: this.state.user.user_id,
      line1: data.line1,
      line2: data.line2,
      town: data.town,
      postcode: data.postcode,
      phone: data.phone,
      region: data.region,
      country: data.country
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/customers/set_shipping_address/',
        addressData, {
          headers: {
            'Authorization': 'Bearer ' + this.state.user.jwt_token
          },
        }
      )
      return result
    } catch (error) {
      // commit('setError', error.response.data)
      return error.response.data
    }
  },

  // Update User Details
  async updateUser({
    commit
  }, data) {
    console.log('USER DETAILS: ', data)
    const userData = {
      customerId: this.state.user.user_id,
      title: data.title,
      firstname: data.firstname,
      middlenames: data.middlenames,
      lastname: data.lastname,
      dateOfBirth: data.dateOfBirth
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/customers/set_names/',
        userData, {
          headers: {
            'Authorization': 'Bearer ' + this.state.user.jwt_token
          },
        }
      )
      return result
    } catch (error) {
      // commit('setError', error.response.data)
      return error.response.data
    }
  },

  // Set user region
  async updateRegion({commit}, data) {
    await commit('setRegion',data)
  },

  // Tracking
  async updateTracking({commit}, status) {
    await commit('setTracking',status)
  },

    // Webinar Banner Dismissed
  async updateWebinarBannerDismissed({commit}, status) {
    await commit('setWebinarBannerDismissed',status)
  },


  // Change a student's classroom (for flexible bookings)
  async changeClassroom({ commit }, data){

    console.log('changeClassroom: ',data)

    const orderId = data.order_id;
    const obpId = data.obp_id;
    const oldClassroomId = data.oldClassroomId;
    const newClassroomId = data.newClassroomId;
    const customerId = this.state.user.user_id;

    // Create the data to send
    const classData = {
      obp_id: Number(obpId),
      customer_id: Number(customerId),
      oldClassroomId: Number(oldClassroomId),
      newClassroomId: Number(newClassroomId),
      order_id: Number(orderId)
    };

    try {
      const result = await this.$axios.$post(
        process.env.DATA_URL + '/orders/changeClassroom/',
        classData
      )
      console.log('Updating classroom: ',result)
      window.location.reload()
      return result
    } catch (error) {
      return error.response.data
    }
  },

  // Ensures email/name are in the store for Enhanced Conversions.
  // Runs on every page load via the footer, but only calls /me if data is missing.
  async ensureProfileData({ commit, state }, $axios) {
    if (!state.isLoggedIn) return
    if (state.email) return // already populated, nothing to do

    try {
      const result = await $axios.$get(
        location.protocol + '//' + location.host + '/.netlify/functions/me',
        { headers: { Authorization: state.jwt_token } }
      )
      commit('setUser', {
        // Spread existing state so we don't wipe jwt/role etc.
        isLoggedIn:  state.isLoggedIn,
        jwt_token:   state.jwt_token,
        user_id:     state.user_id,
        user_role:   state.user_role,
        username:    state.username,
        email:       result.email      || result.username || '',
        first_name:  result.firstname  || '',
        last_name:   result.lastname   || '',
      })
    } catch (e) {
      console.log('Could not fetch profile data for Enhanced Conversions', e)
    }
  },

}
